import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { AngularFireAuth } from '@angular/fire/auth';
import { UsersService } from '../../services/users.service';
export interface Interests {
  value: string;
  viewValue: string;
}
@Component({
  selector: 'app-signup',
  templateUrl: './signup.component.html',
  styleUrls: ['./signup.component.scss']
})
export class SignupComponent implements OnInit {
  form: FormGroup;
  interests: Interests[] = [
    { value: 'Student', viewValue: 'Student' },
    { value: 'Immigrate', viewValue: 'Immigrate' },
    { value: 'Work', viewValue: 'Work' }
  ];
  type: 'signup' | 'login' | 'reset' = 'signup';
  loading = false;
  serverMessage: string;

  constructor(private afAuth: AngularFireAuth, private fb: FormBuilder, private router: Router, private userService: UsersService) { }

  ngOnInit() {
    this.form = this.fb.group({
      name: ['', []],
      email: ['', [Validators.required, Validators.email]],
      age: ['', [, Validators.pattern("^[0-9]*$"), Validators.minLength(3)]],
      country: ['', []],
      interest: ['', []],
      password: ['', [Validators.minLength(6), Validators.required]],
      passwordConfirm: ['', []]
    });
  }

  changeType(val) {
    this.type = val;
  }

  get isSignup() {
    return this.type === 'signup';
  }

  get isLogin() {
    return this.type === 'login';
  }

  get isPasswordReset() {
    return this.type === 'reset';
  }

  get email() {
    return this.form.get('email');
  }

  get name() {
    return this.form.get('name');
  }

  get age() {
    return this.form.get('age');
  }

  get country() {
    return this.form.get('country');
  }

  get interest() {
    return this.form.get('interest');
  }

  get password() {
    return this.form.get('password');
  }

  get passwordConfirm() {
    return this.form.get('passwordConfirm');
  }

  get passwordDoesMatch() {
    if (this.type !== 'signup') {
      return true;
    } else {
      return this.password.value === this.passwordConfirm.value;
    }
  }

  async onSubmit() {
    this.loading = true;

    const email = this.email.value;
    const password = this.password.value;
    const name = this.name.value;
    const age = this.age.value;
    const country = this.country.value;
    const interest = this.interest.value;

    try {
      if (this.isLogin) {
        if (email === 'malini@link2future.ca' && password === 'link2futurepassword!') {
          this.router.navigate(['/dashboard/home']);
        }
        await this.afAuth.signInWithEmailAndPassword(email, password);

      }
      if (this.isSignup) {
        await this.afAuth.createUserWithEmailAndPassword(email, password);


        let userInfo = {};
        userInfo['name'] = name;
        userInfo['email'] = email;
        userInfo['age'] = age;
        userInfo['country'] = country;
        userInfo['interest'] = interest;

        this.userService.createUser(userInfo).then(res => {
          // console.log(res);
        }).catch(err => {
          console.log(err);
        });
        this.router.navigate(['/auth']);
      }
      if (this.isPasswordReset) {
        await this.afAuth.sendPasswordResetEmail(email);
        this.serverMessage = 'Check your email';
      }
    } catch (err) {
      this.serverMessage = err
    }

    this.loading = false;
  }

}
